import React from "react";
import { GetTimeEntryStyle } from "../../sharedCode/HelperMethods";
import { TimeCustomControlProps } from "../../Utils/Interfaces";
import TimeEditorText from "./timeEditorText";
import TimeEditorNative from "./timeEditorNative";
import { TIME_ENTRY_STYLES } from "../../routes/flightPackage/userPreferences";

export default function TimeEditor(props: TimeCustomControlProps): JSX.Element {
    const entryStyle = GetTimeEntryStyle();

    if (entryStyle === TIME_ENTRY_STYLES[0]) {
        return <TimeEditorNative {...props} />;
    }
    return <TimeEditorText {...props} />;
}
